import { render } from "./TalentTotal.vue?vue&type=template&id=353ded50&scoped=true"
import script from "./TalentTotal.vue?vue&type=script&lang=js"
export * from "./TalentTotal.vue?vue&type=script&lang=js"

import "./TalentTotal.vue?vue&type=style&index=0&id=353ded50&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353ded50"]])

export default __exports__